import React from 'react';
import { GovLayout, GovLayoutColumn } from '@gov-design-system-ce/react';
import { useDashboardContextInstance } from '@gov-nx/module/page';
import { DataBoxConnectBanner } from '@gov-nx/ui/web';

export const DashboardDataBoxConnectBanner = () => {
	const { showDataBoxBanner } = useDashboardContextInstance();

	if (!showDataBoxBanner) return null;

	return (
		<GovLayout type="aside">
			<GovLayoutColumn>
				<DataBoxConnectBanner
					requiredTypes={[]}
					translationPrefix="banner-homepage-v1"
				/>
			</GovLayoutColumn>
			<GovLayoutColumn>{''}</GovLayoutColumn>
		</GovLayout>
	);
};
